<template>
  <div>
    <v-card flat>
      <v-card-title>
        Managed Spaces
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="fa-search"
          label="Find a managed space"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="tableItems"
        :search="search"
        show-group-by
        multi-sort dense
        v-model="selected"
        item-key="id"
        :show-select="showSelect"
        :footer-props="{ 'items-per-page-options': [20, 50, 100, -1]}"
      >
        <template v-if="link" v-slot: item.name="{ item }">
          <router-link :to="item.link">{{ item.name }}</router-link>
        </template>
        <template v-slot:[`header.name`]="{ header }">
          {{ header.text.toUpperCase() }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <div class='mytext'>{{ item.name }}</div>
        </template>
        <template v-slot:[`item.spaceType`]="{ item }">
          <div class='mytext'>{{ item.spaceType }}</div>
        </template>
        <template v-slot:[`item.occupancy`]="{ item }">
          <div class='mytext' v-if="item.occupancy !== null">{{ item.occupancy }}</div>
          <div class='mytext' v-if="item.occupancy === null">-</div>
        </template>
        <template v-slot:[`item.lastreading`]="{ item }">
          <div class='mytext'>{{ item.lastreading }}</div>
        </template>
        <template v-slot:[`item.co2`]="{ item }">
          <v-chip
            v-if='item.co2 !== null'
            :color="getColor(item.co2, 'co2')"
            dark
            x-small
            class="short"
          >
            {{ item.co2 }}
          </v-chip>
        </template>
        <template v-slot:[`item.temperature`]="{ item }">
          <v-chip
            v-if='item.temperature !== null'
            :color="getColor(item.temperature, 'temp')"
            dark
            class="short"
          >
            {{ item.temperature }}
          </v-chip>
        </template>
        <template v-slot:[`item.noise`]="{ item }">
          <v-chip
            v-if='item.noise !== null'
            :color="getColor(item.noise, 'noise')"
            dark
            class="short"
          >
            {{ item.noise }}
          </v-chip>
        </template>
        <template v-slot:[`item.humid`]="{ item }">
          <v-chip
            v-if='item.humid !== null && item.humid !== undefined'
            :color="getColor(item.humid, 'humid')"
            dark
            class="short"
          >
            {{ item.humid }}
          </v-chip>
        </template>
        <template v-slot:[`item.tvoc`]="{ item }">
          <v-chip
            v-if='item.tvoc !== undefined && item.tvoc !== null'
            :color="getColor(item.tvoc, 'tvoc')"
            dark
            class="short"
          >
            {{ item.tvoc }}
          </v-chip>
        </template>
        <template v-slot:[`item.aqi`]="{ item }">
          <div v-if="item.aqi === 'N/A'">
            <v-chip
              v-if='item.aqi !== undefined'
              :color="getColor(item.aqi, 'aqi')"
              dark
              class="short"
            >
              {{ item.aqi }}
            </v-chip>
          </div>
          <div v-if="item.aqi !== 'N/A'">
            <v-chip
              v-if='item.aqi !== undefined && item.aqi !== null'
              :color="getColor(item.aqi, 'aqi')"
              dark
              class="short"
            >
              {{ item.aqi }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <div v-if="false">
      <v-card>
        <v-card-title>Debug</v-card-title>
        <v-card-text>
          <p>Headers {{ headers }}</p>
          <!-- <p>Table Items {{ tableItems }}</p> -->
          <p>Selected {{ selected }}</p>
          <!--<p>Data {{ managedSpaces }}</p>-->
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { roundOrNull } from '@/lib/formatUtil'
import moment from 'moment'

export default {
  name: 'managedspacetable',
  props: {
    managedSpaces: Array,
    showSelect: {
      type: Boolean,
      default: false
    },
    link: Boolean
  },
  data: () => {
    return {
      headers: [
        { text: 'Name', value: 'name', filterable: true, groupable: false },
        { text: 'Space Type', value: 'spaceType', groupable: true },
        { text: 'Occupancy', value: 'occupancy', groupable: false },
        { text: 'Temp °C', value: 'temperature', groupable: false },
        { text: 'Noise dB', value: 'noise', groupable: false },
        { text: 'CO2 ppm', value: 'co2', groupable: false },
        { text: 'AQI', value: 'aqi', groupable: false },
        { text: 'TVOC ppm', value: 'tvoc', groupable: false },
        { text: 'Last Reading', value: 'lastreading', groupable: false },
        { text: 'Humidity %', value: 'humid', groupable: false }
      ],
      search: '',
      selected: []
    }
  },
  computed: {
    tableItems: function () {
      if (!this.managedSpaces) {
        return []
      }
      let result = this.managedSpaces.map(space => {
        // console.log('Occupancy', space.sensor.occupancy)
        var arr = space.managedspacegrouphasmanagedspace_set
        var theType
        arr.forEach(element => {
          if (element.managedspacegroup.managedspacegroupset.name === 'Space Type') {
            theType = element.managedspacegroup.name
          }
        })
        // console.log('Space sensor', space.sensor, space.sensor.occupancy)
        if (typeof space.sensor.occupancy === 'undefined') {
          return {
            id: space.id,
            name: space.name,
            aqi: null,
            link: space.link,
            occupancy: null,
            co2: null,
            noise: null,
            tvoc: null,
            temperature: null,
            lastreading: 'No data yet',
            spaceType: theType,
            humid: null
          }
        } else if (space.sensor.devicetype <= 7) {
          return {
            id: space.id,
            name: space.name,
            aqi: 'N/A',
            link: space.link,
            occupancy: space.sensor.occupancy,
            co2: roundOrNull(space.sensor.co2),
            noise: roundOrNull(space.sensor.noise),
            tvoc: space.sensor.voc,
            temperature: roundOrNull(space.sensor.temperature),
            lastreading: this.formatDate(space.sensor.time_utc),
            spaceType: theType,
            humid: space.sensor.humid
          }
        } else {
          return {
            id: space.id,
            name: space.name,
            aqi: space.sensor.aqi2,
            link: space.link,
            occupancy: space.sensor.occupancy,
            co2: roundOrNull(space.sensor.co2hq),
            noise: roundOrNull(space.sensor.noise),
            tvoc: space.sensor.voc,
            temperature: roundOrNull(space.sensor.temperature),
            lastreading: this.formatDate(space.sensor.time_utc),
            spaceType: theType,
            humid: space.sensor.humid
          }
        }
      })
      // console.log('table items', result)
      return result
    }
  },
  watch: {
    selected: function (newSelect) {
      // console.log('Mananged space table - selected changed')
      this.$emit('selected', newSelect)
    }
    // tableItems () {
    //   console.log(this.tableItems)
    // }
  },
  methods: {
    formatDate: function reading (date) {
      return moment(date).format('D/M/YYYY HH:mm')
    },
    getColor (reading, metric) {
      // console.log('Get colour of reading', reading, metric)
      if (reading === null) {
        return 'white'
      }
      switch (metric) {
        case 'co2':
          if (reading > 5000) return '#8e24aa'
          else if (reading >= 1000 && reading <= 5000) return '#f4511e'
          else if (reading >= 800 && reading < 1000) return '#fdd835'
          else if (reading >= 600 && reading < 800) return '#6bca33'
          else return '#43A047'
        case 'temp':
          if (reading > 40 || reading < 15) return '#8e24aa'
          else if ((reading >= 15 && reading <= 17) || (reading >= 29 && reading <= 40)) return '#f4511e'
          else if ((reading >= 18 && reading < 21) || (reading >= 24 && reading < 29)) return '#fdd835'
          else if (reading >= 21 && reading < 30) return '#6bca33'
          else return '#43A047'
        case 'noise':
          if (reading > 87) return '#8e24aa'
          else if (reading >= 60 && reading <= 87) return '#f4511e'
          else if (reading >= 50 && reading < 60) return '#fdd835'
          else if (reading >= 45 && reading < 50) return '#6bca33'
          else return '#43A047'
        case 'tvoc':
          if (reading > 3000) return '#8e24aa'
          else if (reading >= 500 && reading < 3000) return '#f4511e'
          else if (reading >= 300 && reading < 500) return '#fdd835'
          else if (reading >= 100 && reading < 300) return '#6bca33'
          else return '#43A047'
        case 'humid':
          if (reading > 80) return '#8e24aa'
          else if ((reading >= 20 && reading < 30) || (reading > 60 && reading <= 80)) return '#f4511e'
          else if (reading > 50 && reading <= 60) return '#fdd835'
          else if (reading > 40 && reading <= 50) return '#6bca33'
          else if (reading < 20 && reading > 0) return '#8e24aa'
          else return '#43A047'
        case 'aqi':
          if (reading > 400) return '#8e24aa'
          else if (reading >= 300 && reading <= 400) return '#f4511e'
          else if (reading >= 200 && reading < 300) return '#fdd835'
          else if (reading >= 100 && reading < 200) return '#6bca33'
          else if (reading === 'N/A') return '#878682'
          else return '#43A047'
      }
    }
  }
}
</script>

<style scoped>

.mytext {
  font-size: 12px;
}

.short {
  width: 48px;
  font-size: 12px;
  height: 16px;
  margin: 0px;
  padding: 0px;
  justify-content: center;
}

</style>
